import React from 'react';

import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogTitle,
  ActionableDialogContent,
  ActionableDialogActions,
} from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const useStyles = makeMuiStyles((theme, common) => ({
  dialog: {
    maxWidth: '30rem',
    height: '21rem',
  },
  dialogContent: {
    padding: '3rem 3.3rem',
    lineHeight: '1.7rem',
    ...common.bigText,
  },
}));

const strings = createStrings({
  ja: {
    shareInquiry: '予約を共有する',
    sorryYouCannotShare:
      '申し訳ありませんが、予約を共有する権限がありません。予約の作成者のみが予約を共有できます。',
  },
});

interface UnsharableDialogProps {
  open: boolean;
  onClose: () => void;
}
export const UnsharableDialog: React.FC<UnsharableDialogProps> = (props) => {
  const { open, onClose } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <ActionableDialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <ActionableDialogTitle>
        <span className={classes.dialogTitleText}>{strings.shareInquiry}</span>
      </ActionableDialogTitle>
      <ActionableDialogContent className={classes.dialogContent}>
        {strings.sorryYouCannotShare}
      </ActionableDialogContent>
      <ActionableDialogActions>
        <Button color="primary" text={formStrings.ok} size="small" onClick={onClose} />
      </ActionableDialogActions>
    </ActionableDialog>
  );
};
